import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../baseHttpService";

class GeneratePdfService {
  DoGenPdfFromUrl(passCode: string) {
    let url = window.location.href;
    if (passCode) {
      url += `&passcode=${passCode}`;
    }
    const _input = {
      url: url,
      merchantId: MerchantId(),
    };
    return service.peakReportAPI.post("/api/EmailReport/PrintPdf", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new GeneratePdfService();
